import { AsyncPipe, NgClass, SlicePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIcon } from '@angular/material/icon';


import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { I18nModule, provideConfig, StateTransferType } from '@spartacus/core';
import { GenericLinkModule, MediaModule } from '@spartacus/storefront';

import {
  DpHomeProductSubcategoriesComponent,
  DpProductSubcategoryComponent,
  DpProductSubcategorySwitcherComponent,
  DpProductListSubcategoriesComponent
} from './components';
import { productSubcategoriesReducers } from './store';
import { DpSafeHtmlPipe } from '@app/core/pipes/dp-safe-html.pipe';

import { DP_PRODUCT_CATEGORIES_FEATURE } from './store/product-subcategories-state.type';
import * as productSubcategoriesEffects from './store/product-subcategories.effects';

@NgModule({
  declarations: [
    DpHomeProductSubcategoriesComponent,
    DpProductListSubcategoriesComponent,
    DpProductSubcategorySwitcherComponent,
    DpProductSubcategoryComponent
  ],
  exports: [DpHomeProductSubcategoriesComponent, DpProductListSubcategoriesComponent],
  imports: [
    I18nModule,
    MatIcon,
    NgClass,
    StoreModule.forFeature(DP_PRODUCT_CATEGORIES_FEATURE, productSubcategoriesReducers),
    EffectsModule.forFeature(productSubcategoriesEffects),
    AsyncPipe,
    GenericLinkModule,
    MediaModule,
    SlicePipe,
    DpSafeHtmlPipe
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        HomepageProductSubcategoriesComponent: { component: DpHomeProductSubcategoriesComponent },
        ProductListSubcategoriesComponent: { component: DpProductListSubcategoriesComponent }
      }
    }),
    provideConfig({
      state: { ssrTransfer: { keys: { [DP_PRODUCT_CATEGORIES_FEATURE]: StateTransferType.TRANSFER_STATE } } }
    })
  ]
})
export class DpProductSubcategoriesModule {}
